// src/locales.js

export const resources = {
  // ================= АНГЛІЙСЬКА (EN) =================
  en: {
    translation: {
      common: {
        back: "Back",
        next: "Next Step",
        continue: "Continue",
        returnHome: "Return Home",
        loading: "Loading...",
        processing: "Processing...",
        step: "Step" // <--- Ключ для StepCard
      },
      nav: {
        getStarted: "Get Started",
        howItWorks: "How It Works",
        faq: "FAQ",
        contact: "Contact",
        followUs: "Follow Us",
        quickLinks: "Quick Links"
      },
      home: {
        heroTitle: "Your child. Their face. A story that feels real.",
        heroSubtitle: "Turn a single front‑facing photo into a beautifully illustrated book where your child becomes the main character—page after page, scene after scene.",
        pill1: "No complex setup",
        pill2: "Natural, friendly look",
        pill3: "Consistent hero on every page",
        ctaStart: "Create Your Child's Story",
        stepsTitle: "How it works",
        stepsIntro: "Simple steps. A magical result.",
        step1Title: "Choose a book & Upload 2 photos",
        step1Text: "Pick a series from our enchanting collection, enter your child’s name, and prepare to bring their story to life. Then, simply upload two clear, front-facing photos of your child, ideally with a gentle smile.",
        step1List: {
            li1: "Front‑facing, no heavy filters",
            li2: "Good lighting, no harsh shadows",
            li3: "Relaxed expression, gentle smile"
        },
        step2Title: "Personalization magic",
        step2Text: "Our special models detect and transfer facial features with care—so your child looks like themselves in every scene.",
        step3Title: "Preview & Order",
        step3Text: "Flip through your pages online to make sure everything looks perfect. When you’re happy, check out securely to place the order.",
        step4Title: "Printed & delivered",
        step4Text: "Your book is printed on quality paper with rich colors, then carefully packed and shipped to your door.",
        qualityTitle: "Why it looks so real",
        qualityIntro: "Little details make a big difference.",
        qualityList: {
            item1Title: "True‑to‑life likeness",
            item1Text: "We retain key facial features and natural expressions.",
            item2Title: "One consistent hero",
            item2Text: "The same child, across all pages and scenes.",
            item3Title: "Clean illustrations",
            item3Text: "No random text or watermarks on images.",
            item4Title: "Cohesive style",
            item4Text: "Soft colors, balanced compositions, and plenty of breathing room."
        },
        get: {
            title: "What you get",
            item1Title: "Your personalized book",
            item1Text: "From the first page to the last, a story starring your child, in a single harmonious style.",
            item2Title: "Beautiful illustrations",
            item2Text: "Clean, vibrant scenes designed for print and delightful to read together.",
            item3Title: "Proper cover & interior",
            item3Text: "A polished cover plus page layout prepared for high‑quality printing.",
            item4Title: "Printed and shipped",
            item4Text: "Professionally printed on quality paper and delivered to your address."
        },
        reviewsTitle: "Happy Families Share Their Joy",
        bottomCtaTitle: "Ready to create your child’s magical story?",
        bottomCtaText: "Start their adventure today with a personalized storybook they’ll treasure forever.",
        bottomCtaButton: "Create your story now"
      },
      faq: {
        q1: "Will the hero look the same on every page?",
        a1: "Yes. Your child remains the same main character throughout the entire book.",
        q2: "Do I need multiple photos?",
        a2: "Usually a single clear, front‑facing photo with a gentle smile is enough.",
        q3: "Can I preview before paying?",
        a3: "Absolutely. You can view the pages online and proceed only when you’re happy.",
        q4: "How long does printing & shipping take?",
        a4: "It depends on your location. After checkout we’ll provide an estimated timeline."
      },
      stepper: {
        step1: "Choose Book",
        step2: "Child's Details",
        step3: "Generating Book",
        step4: "Preview & Purchase",
      },
      chooseBook: {
        title: "Pick a Story for Your Child",
        subtitle: "Select an age group and then choose a magical adventure.",
        ages1_3: "Ages 1-3",
        ages4_8: "Ages 4-8",
        tooltip: "The book cover is for illustrative purposes only and may not be the final design.",
        titles: {
            101: "Alphabet Journey",
            102: "Sounds from the Zoo",
            103: "The Magic Garden",
            201: "Magical Forest Adventure",
            202: "The Little Lantern Keeper",
            203: "What Can You Be?",
            301: "Christmas Wish",
            302: "The Christmas Journey"
        }
      },
      childInfo: {
        title: "Tell Us About Your Little Hero",
        subtitle: "This information will help us personalize the story.",
        uploadTitle: "Upload Photos",
        clickUpload: "Click to upload photo",
        guidelines: "Please provide two clear, front-facing photos of your child.",
        detailsTitle: "Child's Details",
        firstName: "Child's First Name",
        lastName: "Child's Last Name",
        gender: "Gender",
        age: "Age",
        email: "Your Email",
        options: {
            male: "Male",
            female: "Female",
            year: "year",
            years: "years"
        },
        errors: {
            firstName: "Please enter first name",
            lastName: "Please enter last name",
            gender: "Please select gender",
            age: "Please select age",
            emailRequired: "Please enter email",
            emailInvalid: "Email is invalid",
            photosRequired: "Both photos are required"
        }
      },
      loading: {
        preparing: "Preparing your campaign...",
        resuming: "Resuming your session...",
        creating: "Creating your campaign...",
        generating: "Generating your personalized book...",
        ready: "Ready to preview!",
        notify: "We will send you an email when the book is ready to be previewed",
        waitText: "If you choose to wait, here are some interesting facts:",
        loadingFacts: "Loading facts...",
        error: "An error occurred: {{message}}. Please refresh page."
      },
      pricing: {
        title: "Simple, Transparent Pricing",
        badge: "BEST VALUE",
        packTitle: "Complete Magic Pack",
        packSubtitle: "One price for everything. No hidden fees.",
        list: {
            item1: "Personalized AI Generation (PDF included)",
            item2: "Premium Hardcover Book (20x20 cm)",
            item3: "High-Quality Thick Paper",
            item4: "Free Worldwide Shipping",
            item5: "Priority Printing Queue"
        },
        bonusTitle: "BONUS: Kids' Creativity Kit",
        bonusSubtitle: "Includes coloring pages & premium marker set",
        totalPriceLabel: "Total Price",
        price: "2000₽",
        subPrice: "(approx. $24.95)",
        ctaButton: "Create My Book Now",
        guarantee: "100% Satisfaction Guarantee"
      },
      purchase: {
        reviewTitle: "Review & Select Your Pages",
        reviewSubtitle: "Use the arrows to switch between variants for each page. The visible version will be selected.",
        pageCount: "Page {{current}} of {{total}}",
        variantSelected: "Option {{number}} selected for this page", // <--- Тут "Option"
        shippingTitle: "Shipping & Payment",
        contactInfo: "Contact Information",
        shippingAddr: "Shipping Address",
        labels: {
            email: "Email",
            firstName: "First name",
            lastName: "Last name",
            country: "Country",
            address1: "Address 1",
            address2: "Address 2 (Apartment, suite, etc.)",
            state: "State / Region",
            city: "City",
            zip: "Postal / ZIP code",
            phone: "Phone"
        },
        helpers: {
            address1: "{{length}}/30. (e.g., building, apt number)",
            address2: "{{length}}/30. (e.g., street name, district)"
        },
        payBtn: "Proceed to Payment",
        tabs: {
            select: "Select Pages",
            shipping: "Shipping Info"
        },
        errors: {
            email: "Please enter a valid email address.",
            required: "{{field}} is required.",
            addressLong: "{{field}} cannot be longer than 30 characters.",
            zipFormat: "Please enter a valid postal/ZIP code format for {{country}}.",
            zipInvalid: "The postal code '{{zip}}' does not seem to exist in {{country}}.",
            zipMismatch: "The postal code '{{zip}}' is valid, but it belongs to {{stateApi}}, not {{stateUser}}.",
            zipApiError: "Could not verify your postal code right now. Please try again in a moment.",
            variant: "Please select a variant for every page."
        }
      },
      success: {
        title: "Payment Successful!",
        message: "Your order <strong>#{{orderId}}</strong> has been successfully placed and paid for.",
        printing: "We have started generating the high-resolution pages and preparing your book for print.",
        delivery: "Estimated printing & delivery: <strong>12 days</strong>.",
        emailNote: "A detailed confirmation email with all order tracking information has been sent to your inbox.",
        contact: "Questions? Contact Support:"
      },
      footer: {
        tagline: "Making your child the hero of their own magical adventure.",
      }
    }
  },

  // ================= ФРАНЦУЗЬКА (FR) =================
  fr: {
    translation: {
      common: {
        back: "Retour",
        next: "Étape suivante",
        continue: "Continuer",
        returnHome: "Retour à l'accueil",
        loading: "Chargement...",
        processing: "Traitement...",
        step: "Étape" // <--- ОСЬ ТУТ БУЛО ПРОПУЩЕНО
      },
      nav: {
        getStarted: "Commencer",
        howItWorks: "Comment ça marche",
        faq: "FAQ",
        contact: "Contact",
        followUs: "Suivez-nous",
        quickLinks: "Liens rapides"
      },
      home: {
        heroTitle: "Votre enfant. Son visage. Une histoire plus vraie que nature.",
        heroSubtitle: "Transformez une simple photo de face en un livre magnifiquement illustré où votre enfant devient le héros principal, page après page.",
        pill1: "Configuration simple",
        pill2: "Look naturel",
        pill3: "Héros cohérent",
        ctaStart: "Créer l'histoire",
        stepsTitle: "Comment ça marche",
        stepsIntro: "Des étapes simples. Un résultat magique.",
        step1Title: "Choisissez un livre et téléchargez 2 photos",
        step1Text: "Choisissez une série, entrez le nom de votre enfant et préparez-vous à donner vie à son histoire. Téléchargez simplement deux photos claires de face.",
        step1List: {
            li1: "De face, sans filtres lourds",
            li2: "Bon éclairage, pas d'ombres",
            li3: "Expression détendue"
        },
        step2Title: "Magie de la personnalisation",
        step2Text: "Nos modèles détectent et transfèrent les traits du visage avec soin, pour que votre enfant se reconnaisse dans chaque scène.",
        step3Title: "Aperçu et Commande",
        step3Text: "Feuilletez vos pages en ligne pour vous assurer que tout est parfait. Lorsque vous êtes satisfait, passez commande en toute sécurité.",
        step4Title: "Imprimé et livré",
        step4Text: "Votre livre est imprimé sur du papier de qualité, puis soigneusement emballé et expédié chez vous.",
        qualityTitle: "Pourquoi c'est si réaliste",
        qualityIntro: "Les petits détails font la différence.",
        qualityList: {
            item1Title: "Ressemblance fidèle",
            item1Text: "Nous conservons les traits clés du visage et les expressions naturelles.",
            item2Title: "Héros unique",
            item2Text: "Le même enfant, à travers toutes les pages et scènes.",
            item3Title: "Illustrations épurées",
            item3Text: "Pas de texte aléatoire ou de filigranes sur les images.",
            item4Title: "Style cohérent",
            item4Text: "Couleurs douces, compositions équilibrées et beaucoup d'espace."
        },
        get: {
            title: "Ce que vous obtenez",
            item1Title: "Votre livre personnalisé",
            item1Text: "De la première à la dernière page, une histoire mettant en vedette votre enfant.",
            item2Title: "Belles illustrations",
            item2Text: "Des scènes vibrantes conçues pour l'impression et agréables à lire ensemble.",
            item3Title: "Couverture et intérieur soignés",
            item3Text: "Une couverture soignée et une mise en page préparée pour une impression de haute qualité.",
            item4Title: "Imprimé et expédié",
            item4Text: "Imprimé professionnellement sur du papier de qualité et livré à votre adresse."
        },
        reviewsTitle: "Les familles partagent leur joie",
        bottomCtaTitle: "Prêt à créer l'histoire magique de votre enfant ?",
        bottomCtaText: "Commencez l'aventure aujourd'hui avec un livre personnalisé qu'ils chériront pour toujours.",
        bottomCtaButton: "Créer votre histoire maintenant"
      },
      faq: {
        q1: "Le héros aura-t-il la même apparence sur chaque page ?",
        a1: "Oui. Votre enfant reste le même personnage principal tout au long du livre.",
        q2: "Ai-je besoin de plusieurs photos ?",
        a2: "Généralement, une seule photo claire de face avec un léger sourire suffit.",
        q3: "Puis-je prévisualiser avant de payer ?",
        a3: "Absolument. Vous pouvez voir les pages en ligne et procéder uniquement lorsque vous êtes satisfait.",
        q4: "Combien de temps prennent l'impression et l'expédition ?",
        a4: "Cela dépend de votre emplacement. Après le paiement, nous vous fournirons une estimation."
      },
      stepper: {
        step1: "Choisir un livre",
        step2: "Détails de l'enfant",
        step3: "Génération du livre",
        step4: "Aperçu et Achat",
      },
      chooseBook: {
        title: "Choisissez une histoire pour votre enfant",
        subtitle: "Sélectionnez un groupe d'âge puis choisissez une aventure magique.",
        ages1_3: "Âges 1-3",
        ages4_8: "Âges 4-8",
        tooltip: "La couverture du livre est à titre indicatif uniquement et peut ne pas être le design final.",
        titles: {
            101: "Voyage Alphabétique",
            102: "Sons du Zoo",
            103: "Le Jardin Magique",
            201: "Aventure en Forêt Magique",
            202: "Le Petit Gardien de Lanterne",
            203: "Que peux-tu devenir ?",
            301: "Vœu de Noël",
            302: "Le Voyage de Noël"
        }
      },
      childInfo: {
        title: "Parlez-nous de votre petit héros",
        subtitle: "Ces informations nous aideront à personnaliser l'histoire.",
        uploadTitle: "Télécharger des photos",
        clickUpload: "Cliquez pour télécharger",
        guidelines: "Veuillez fournir deux photos claires et de face de votre enfant.",
        detailsTitle: "Détails de l'enfant",
        firstName: "Prénom de l'enfant",
        lastName: "Nom de l'enfant",
        gender: "Genre",
        age: "Âge",
        email: "Votre Email",
        options: {
            male: "Garçon",
            female: "Fille",
            year: "an",
            years: "ans"
        },
        errors: {
            firstName: "Veuillez entrer le prénom",
            lastName: "Veuillez entrer le nom",
            gender: "Veuillez sélectionner le genre",
            age: "Veuillez sélectionner l'âge",
            emailRequired: "Veuillez entrer l'email",
            emailInvalid: "Email invalide",
            photosRequired: "Les deux photos sont requises"
        }
      },
      loading: {
        preparing: "Préparation de votre campagne...",
        resuming: "Reprise de votre session...",
        creating: "Création de votre campagne...",
        generating: "Génération de votre livre personnalisé...",
        ready: "Prêt pour l'aperçu !",
        notify: "Nous vous enverrons un email lorsque le livre sera prêt à être prévisualisé.",
        waitText: "Si vous choisissez d'attendre, voici quelques faits intéressants :",
        loadingFacts: "Chargement des faits...",
        error: "Une erreur est survenue : {{message}}. Veuillez rafraîchir la page."
      },
      purchase: {
        reviewTitle: "Vérifiez et sélectionnez vos pages",
        reviewSubtitle: "Utilisez les flèches pour changer de variante pour chaque page. La version visible sera sélectionnée.",
        pageCount: "Page {{current}} sur {{total}}",
        variantSelected: "Variante {{number}} sélectionnée", // <--- Тут "Variante" замість "Option"
        shippingTitle: "Livraison et Paiement",
        contactInfo: "Informations de contact",
        shippingAddr: "Adresse de livraison",
        labels: {
            email: "Email",
            firstName: "Prénom",
            lastName: "Nom",
            country: "Pays",
            address1: "Adresse 1",
            address2: "Adresse 2 (Appartement, suite, etc.)",
            state: "État / Région",
            city: "Ville",
            zip: "Code postal",
            phone: "Téléphone"
        },
        helpers: {
            address1: "{{length}}/30. (ex: bâtiment, n° apt)",
            address2: "{{length}}/30. (ex: rue, quartier)"
        },
        payBtn: "Procéder au paiement",
        tabs: {
            select: "Sélectionner Pages",
            shipping: "Info Livraison"
        },
        errors: {
            email: "Veuillez entrer une adresse email valide.",
            required: "{{field}} est requis.",
            addressLong: "{{field}} ne peut pas dépasser 30 caractères.",
            zipFormat: "Veuillez entrer un format de code postal valide pour {{country}}.",
            zipInvalid: "Le code postal '{{zip}}' ne semble pas exister en {{country}}.",
            zipMismatch: "Le code postal '{{zip}}' est valide, mais il appartient à {{stateApi}}, pas à {{stateUser}}.",
            zipApiError: "Impossible de vérifier votre code postal pour le moment. Veuillez réessayer.",
            variant: "Veuillez sélectionner une variante pour chaque page."
        }
      },
      success: {
        title: "Paiement réussi !",
        message: "Votre commande <strong>#{{orderId}}</strong> a été passée et payée avec succès.",
        printing: "Nous avons commencé à générer les pages haute résolution et à préparer votre livre pour l'impression.",
        delivery: "Impression et livraison estimées : <strong>12 jours</strong>.",
        emailNote: "Un email de confirmation détaillé avec toutes les informations de suivi a été envoyé à votre boîte de réception.",
        contact: "Des questions ? Contactez le support :"
      },
      footer: {
        tagline: "Faire de votre enfant le héros de sa propre aventure magique.",
      }
    }
  },

  // ================= ІСПАНСЬКА (ES) =================
  es: {
    translation: {
      common: {
        back: "Atrás",
        next: "Siguiente Paso",
        continue: "Continuar",
        returnHome: "Volver al Inicio",
        loading: "Cargando...",
        processing: "Procesando...",
        step: "Paso" // <--- ОСЬ ТУТ БУЛО ПРОПУЩЕНО
      },
      nav: {
        getStarted: "Empezar",
        howItWorks: "Cómo Funciona",
        faq: "FAQ",
        contact: "Contacto",
        followUs: "Síguenos",
        quickLinks: "Enlaces Rápidos"
      },
      home: {
        heroTitle: "Tu hijo. Su cara. Una historia que parece real.",
        heroSubtitle: "Convierte una sola foto de frente en un libro bellamente ilustrado donde tu hijo se convierte en el personaje principal, página tras página.",
        pill1: "Sin configuración compleja",
        pill2: "Aspecto natural y amigable",
        pill3: "Héroe consistente en cada página",
        ctaStart: "Crea la Historia de tu Hijo",
        stepsTitle: "Cómo funciona",
        stepsIntro: "Pasos simples. Un resultado mágico.",
        step1Title: "Elige un libro y sube 2 fotos",
        step1Text: "Elige una serie de nuestra colección encantadora, ingresa el nombre de tu hijo y prepárate para dar vida a su historia. Luego, simplemente sube dos fotos claras de frente, idealmente con una sonrisa suave.",
        step1List: {
            li1: "De frente, sin filtros pesados",
            li2: "Buena iluminación, sin sombras duras",
            li3: "Expresión relajada, sonrisa suave"
        },
        step2Title: "Magia de personalización",
        step2Text: "Nuestros modelos especiales detectan y transfieren los rasgos faciales con cuidado, para que tu hijo se vea como él mismo en cada escena.",
        step3Title: "Vista previa y Pedido",
        step3Text: "Hojee sus páginas en línea para asegurarse de que todo se vea perfecto. Cuando esté feliz, realice el pedido de forma segura.",
        step4Title: "Impreso y entregado",
        step4Text: "Tu libro se imprime en papel de calidad con colores ricos, luego se empaqueta cuidadosamente y se envía a tu puerta.",
        qualityTitle: "Por qué se ve tan real",
        qualityIntro: "Los pequeños detalles marcan una gran diferencia.",
        qualityList: {
            item1Title: "Semejanza fiel",
            item1Text: "Conservamos los rasgos faciales clave y las expresiones naturales.",
            item2Title: "Un héroe consistente",
            item2Text: "El mismo niño, a través de todas las páginas y escenas.",
            item3Title: "Ilustraciones limpias",
            item3Text: "Sin texto aleatorio ni marcas de agua en las imágenes.",
            item4Title: "Estilo cohesivo",
            item4Text: "Colores suaves, composiciones equilibradas y mucho espacio."
        },
        get: {
            title: "Lo que obtienes",
            item1Title: "Tu libro personalizado",
            item1Text: "Desde la primera página hasta la última, una historia protagonizada por tu hijo, en un estilo armonioso.",
            item2Title: "Hermosas ilustraciones",
            item2Text: "Escenas vibrantes y limpias diseñadas para imprimir y agradables de leer juntos.",
            item3Title: "Cubierta e interior adecuados",
            item3Text: "Una cubierta pulida más un diseño de página preparado para una impresión de alta calidad.",
            item4Title: "Impreso y enviado",
            item4Text: "Impreso profesionalmente en papel de calidad y entregado en tu dirección."
        },
        reviewsTitle: "Familias felices comparten su alegría",
        bottomCtaTitle: "¿Listo para crear la historia mágica de tu hijo?",
        bottomCtaText: "Comienza su aventura hoy con un libro de cuentos personalizado que atesorarán por siempre.",
        bottomCtaButton: "Crea tu historia ahora"
      },
      faq: {
        q1: "¿El héroe se verá igual en cada página?",
        a1: "Sí. Tu hijo sigue siendo el mismo personaje principal a lo largo de todo el libro.",
        q2: "¿Necesito varias fotos?",
        a2: "Por lo general, una sola foto clara de frente con una sonrisa suave es suficiente.",
        q3: "¿Puedo ver una vista previa antes de pagar?",
        a3: "Absolutamente. Puedes ver las páginas en línea y proceder solo cuando estés contento.",
        q4: "¿Cuánto tiempo tarda la impresión y el envío?",
        a4: "Depende de tu ubicación. Después del pago, proporcionaremos un cronograma estimado."
      },
      stepper: {
        step1: "Elegir Libro",
        step2: "Detalles del Niño",
        step3: "Generando Libro",
        step4: "Vista Previa y Compra",
      },
      chooseBook: {
        title: "Elige una Historia para tu Hijo",
        subtitle: "Selecciona un grupo de edad y luego elige una aventura mágica.",
        ages1_3: "Edades 1-3",
        ages4_8: "Edades 4-8",
        tooltip: "La portada del libro es solo para fines ilustrativos y puede no ser el diseño final.",
        titles: {
            101: "Viaje del Alfabeto",
            102: "Sonidos del Zoológico",
            103: "El Jardín Mágico",
            201: "Aventura en el Bosque Mágico",
            202: "El Pequeño Guardián de la Linterna",
            203: "¿Qué Puedes Ser?",
            301: "Deseo de Navidad",
            302: "El Viaje de Navidad"
        }
      },
      childInfo: {
        title: "Cuéntanos sobre tu Pequeño Héroe",
        subtitle: "Esta información nos ayudará a personalizar la historia.",
        uploadTitle: "Subir Fotos",
        clickUpload: "Clic para subir foto",
        guidelines: "Por favor proporciona dos fotos claras y de frente de tu hijo.",
        detailsTitle: "Detalles del Niño",
        firstName: "Nombre del Niño",
        lastName: "Apellido del Niño",
        gender: "Género",
        age: "Edad",
        email: "Tu Email",
        options: {
            male: "Niño",
            female: "Niña",
            year: "año",
            years: "años"
        },
        errors: {
            firstName: "Por favor ingresa el nombre",
            lastName: "Por favor ingresa el apellido",
            gender: "Por favor selecciona el género",
            age: "Por favor selecciona la edad",
            emailRequired: "Por favor ingresa el email",
            emailInvalid: "El email es inválido",
            photosRequired: "Se requieren ambas fotos"
        }
      },
      loading: {
        preparing: "Preparando tu campaña...",
        resuming: "Reanudando tu sesión...",
        creating: "Creando tu campaña...",
        generating: "Generando tu libro personalizado...",
        ready: "¡Listo para ver!",
        notify: "Te enviaremos un email cuando el libro esté listo para ser visto.",
        waitText: "Si eliges esperar, aquí hay algunos datos interesantes:",
        loadingFacts: "Cargando datos...",
        error: "Ocurrió un error: {{message}}. Por favor actualiza la página."
      },
      purchase: {
        reviewTitle: "Revisa y Selecciona tus Páginas",
        reviewSubtitle: "Usa las flechas para cambiar entre variantes para cada página. Se seleccionará la versión visible.",
        pageCount: "Página {{current}} de {{total}}",
        variantSelected: "Opción {{number}} seleccionada", // <--- Тут "Opción"
        shippingTitle: "Envío y Pago",
        contactInfo: "Información de Contacto",
        shippingAddr: "Dirección de Envío",
        labels: {
            email: "Email",
            firstName: "Nombre",
            lastName: "Apellido",
            country: "País",
            address1: "Dirección 1",
            address2: "Dirección 2 (Apartamento, suite, etc.)",
            state: "Estado / Región",
            city: "Ciudad",
            zip: "Código Postal",
            phone: "Teléfono"
        },
        helpers: {
            address1: "{{length}}/30. (ej: edificio, num apt)",
            address2: "{{length}}/30. (ej: nombre calle, distrito)"
        },
        payBtn: "Proceder al Pago",
        tabs: {
            select: "Seleccionar Páginas",
            shipping: "Info de Envío"
        },
        errors: {
            email: "Por favor ingresa una dirección de email válida.",
            required: "{{field}} es requerido.",
            addressLong: "{{field}} no puede tener más de 30 caracteres.",
            zipFormat: "Por favor ingresa un formato de código postal válido para {{country}}.",
            zipInvalid: "El código postal '{{zip}}' no parece existir en {{country}}.",
            zipMismatch: "El código postal '{{zip}}' es válido, pero pertenece a {{stateApi}}, no a {{stateUser}}.",
            zipApiError: "No se pudo verificar tu código postal en este momento. Por favor intenta de nuevo.",
            variant: "Por favor selecciona una variante para cada página."
        }
      },
      success: {
        title: "¡Pago Exitoso!",
        message: "Tu pedido <strong>#{{orderId}}</strong> ha sido realizado y pagado exitosamente.",
        printing: "Hemos comenzado a generar las páginas de alta resolución y a preparar tu libro para impresión.",
        delivery: "Impresión y entrega estimadas: <strong>12 días</strong>.",
        emailNote: "Se ha enviado un email de confirmación detallado con toda la información de seguimiento a tu bandeja de entrada.",
        contact: "¿Preguntas? Contacta a Soporte:"
      },
      footer: {
        tagline: "Convierte a tu hijo en el héroe de su propia aventura mágica.",
      }
    }
  },

  // ================= НІМЕЦЬКА (DE) =================
  de: {
    translation: {
      common: {
        back: "Zurück",
        next: "Nächster Schritt",
        continue: "Weiter",
        returnHome: "Zurück zur Startseite",
        loading: "Laden...",
        processing: "Verarbeitung...",
        step: "Schritt" // <--- ОСЬ ТУТ БУЛО ПРОПУЩЕНО
      },
      nav: {
        getStarted: "Loslegen",
        howItWorks: "Wie es funktioniert",
        faq: "FAQ",
        contact: "Kontakt",
        followUs: "Folgen Sie uns",
        quickLinks: "Schnelllinks"
      },
      home: {
        heroTitle: "Dein Kind. Sein Gesicht. Eine Geschichte, die sich echt anfühlt.",
        heroSubtitle: "Verwandle ein einzelnes Frontalfoto in ein wunderschön illustriertes Buch, in dem dein Kind zur Hauptfigur wird – Seite für Seite, Szene für Szene.",
        pill1: "Keine komplexe Einrichtung",
        pill2: "Natürlicher, freundlicher Look",
        pill3: "Konsistenter Held auf jeder Seite",
        ctaStart: "Erstelle die Geschichte deines Kindes",
        stepsTitle: "Wie es funktioniert",
        stepsIntro: "Einfache Schritte. Ein magisches Ergebnis.",
        step1Title: "Buch wählen & 2 Fotos hochladen",
        step1Text: "Wähle eine Serie aus unserer bezaubernden Sammlung, gib den Namen deines Kindes ein und bereite dich darauf vor, seine Geschichte zum Leben zu erwecken. Lade dann einfach zwei klare Frontalfotos deines Kindes hoch, idealerweise mit einem sanften Lächeln.",
        step1List: {
            li1: "Frontal, keine starken Filter",
            li2: "Gutes Licht, keine harten Schatten",
            li3: "Entspannter Ausdruck, sanftes Lächeln"
        },
        step2Title: "Magie der Personalisierung",
        step2Text: "Unsere speziellen Modelle erkennen und übertragen Gesichtszüge sorgfältig, damit dein Kind in jeder Szene wie es selbst aussieht.",
        step3Title: "Vorschau & Bestellen",
        step3Text: "Blättern Sie online durch Ihre Seiten, um sicherzustellen, dass alles perfekt aussieht. Wenn Sie zufrieden sind, bestellen Sie sicher.",
        step4Title: "Gedruckt & geliefert",
        step4Text: "Ihr Buch wird auf Qualitätspapier mit satten Farben gedruckt, dann sorgfältig verpackt und an Ihre Haustür geliefert.",
        qualityTitle: "Warum es so echt aussieht",
        qualityIntro: "Kleine Details machen einen großen Unterschied.",
        qualityList: {
            item1Title: "Echte Ähnlichkeit",
            item1Text: "Wir behalten wichtige Gesichtszüge und natürliche Ausdrücke bei.",
            item2Title: "Ein konsistenter Held",
            item2Text: "Dasselbe Kind, über alle Seiten und Szenen hinweg.",
            item3Title: "Saubere Illustrationen",
            item3Text: "Kein zufälliger Text oder Wasserzeichen auf Bildern.",
            item4Title: "Kohärenter Stil",
            item4Text: "Weiche Farben, ausgewogene Kompositionen und viel Raum."
        },
        get: {
            title: "Was Sie bekommen",
            item1Title: "Ihr personalisiertes Buch",
            item1Text: "Von der ersten bis zur letzten Seite eine Geschichte mit Ihrem Kind in einem harmonischen Stil.",
            item2Title: "Wunderschöne Illustrationen",
            item2Text: "Saubere, lebendige Szenen, die für den Druck entworfen wurden und Freude beim gemeinsamen Lesen bereiten.",
            item3Title: "Ordentliches Cover & Interieur",
            item3Text: "Ein poliertes Cover sowie ein Seitenlayout, das für hochwertigen Druck vorbereitet ist.",
            item4Title: "Gedruckt und versandt",
            item4Text: "Professionell auf Qualitätspapier gedruckt und an Ihre Adresse geliefert."
        },
        reviewsTitle: "Glückliche Familien teilen ihre Freude",
        bottomCtaTitle: "Bereit, die magische Geschichte Ihres Kindes zu erstellen?",
        bottomCtaText: "Starten Sie ihr Abenteuer heute mit einem personalisierten Geschichtenbuch, das sie für immer schätzen werden.",
        bottomCtaButton: "Erstellen Sie Ihre Geschichte jetzt"
      },
      faq: {
        q1: "Wird der Held auf jeder Seite gleich aussehen?",
        a1: "Ja. Ihr Kind bleibt im gesamten Buch dieselbe Hauptfigur.",
        q2: "Brauche ich mehrere Fotos?",
        a2: "Normalerweise reicht ein einzelnes klares Frontalfoto mit einem sanften Lächeln aus.",
        q3: "Kann ich vor dem Bezahlen eine Vorschau sehen?",
        a3: "Absolut. Sie können die Seiten online ansehen und erst fortfahren, wenn Sie zufrieden sind.",
        q4: "Wie lange dauern Druck & Versand?",
        a4: "Das hängt von Ihrem Standort ab. Nach der Bestellung erhalten Sie einen geschätzten Zeitplan."
      },
      stepper: {
        step1: "Buch wählen",
        step2: "Details des Kindes",
        step3: "Buch generieren",
        step4: "Vorschau & Kauf",
      },
      chooseBook: {
        title: "Wähle eine Geschichte für dein Kind",
        subtitle: "Wähle eine Altersgruppe und dann ein magisches Abenteuer.",
        ages1_3: "Alter 1-3",
        ages4_8: "Alter 4-8",
        tooltip: "Das Buchcover dient nur zur Veranschaulichung und ist möglicherweise nicht das endgültige Design.",
        titles: {
            101: "Alphabet-Reise",
            102: "Geräusche aus dem Zoo",
            103: "Der Zaubergarten",
            201: "Abenteuer im Zauberwald",
            202: "Der kleine Laternenwächter",
            203: "Was kannst du sein?",
            301: "Weihnachtswunsch",
            302: "Die Weihnachtsreise"
        }
      },
      childInfo: {
        title: "Erzähl uns von deinem kleinen Helden",
        subtitle: "Diese Informationen helfen uns, die Geschichte zu personalisieren.",
        uploadTitle: "Fotos hochladen",
        clickUpload: "Klicken zum Hochladen",
        guidelines: "Bitte stellen Sie zwei klare Frontalfotos Ihres Kindes zur Verfügung.",
        detailsTitle: "Details des Kindes",
        firstName: "Vorname des Kindes",
        lastName: "Nachname des Kindes",
        gender: "Geschlecht",
        age: "Alter",
        email: "Deine E-Mail",
        options: {
            male: "Junge",
            female: "Mädchen",
            year: "Jahr",
            years: "Jahre"
        },
        errors: {
            firstName: "Bitte Vorname eingeben",
            lastName: "Bitte Nachname eingeben",
            gender: "Bitte Geschlecht wählen",
            age: "Bitte Alter wählen",
            emailRequired: "Bitte E-Mail eingeben",
            emailInvalid: "E-Mail ist ungültig",
            photosRequired: "Beide Fotos sind erforderlich"
        }
      },
      loading: {
        preparing: "Bereite Ihre Kampagne vor...",
        resuming: "Nehme Ihre Sitzung wieder auf...",
        creating: "Erstelle Ihre Kampagne...",
        generating: "Generiere Ihr personalisiertes Buch...",
        ready: "Bereit zur Vorschau!",
        notify: "Wir senden Ihnen eine E-Mail, wenn das Buch zur Vorschau bereit ist.",
        waitText: "Wenn Sie warten möchten, hier sind einige interessante Fakten:",
        loadingFacts: "Lade Fakten...",
        error: "Ein Fehler ist aufgetreten: {{message}}. Bitte Seite aktualisieren."
      },
      purchase: {
        reviewTitle: "Überprüfen & Wählen Sie Ihre Seiten",
        reviewSubtitle: "Verwenden Sie die Pfeile, um zwischen den Varianten für jede Seite zu wechseln. Die sichtbare Version wird ausgewählt.",
        pageCount: "Seite {{current}} von {{total}}",
        variantSelected: "Variante {{number}} ausgewählt", // <--- Тут "Variante" замість "Option"
        shippingTitle: "Versand & Zahlung",
        contactInfo: "Kontaktinformationen",
        shippingAddr: "Lieferadresse",
        labels: {
            email: "E-Mail",
            firstName: "Vorname",
            lastName: "Nachname",
            country: "Land",
            address1: "Adresse 1",
            address2: "Adresse 2 (Wohnung, Suite, etc.)",
            state: "Bundesland / Region",
            city: "Stadt",
            zip: "PLZ",
            phone: "Telefon"
        },
        helpers: {
            address1: "{{length}}/30. (z.B. Gebäude, Wohnungsnr.)",
            address2: "{{length}}/30. (z.B. Straßenname, Bezirk)"
        },
        payBtn: "Zur Kasse",
        tabs: {
            select: "Seiten wählen",
            shipping: "Versandinfo"
        },
        errors: {
            email: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
            required: "{{field}} ist erforderlich.",
            addressLong: "{{field}} darf nicht länger als 30 Zeichen sein.",
            zipFormat: "Bitte geben Sie ein gültiges PLZ-Format für {{country}} ein.",
            zipInvalid: "Die PLZ '{{zip}}' scheint in {{country}} nicht zu existieren.",
            zipMismatch: "Die PLZ '{{zip}}' ist gültig, gehört aber zu {{stateApi}}, nicht zu {{stateUser}}.",
            zipApiError: "Konnte Ihre PLZ derzeit nicht überprüfen. Bitte versuchen Sie es gleich noch einmal.",
            variant: "Bitte wählen Sie eine Variante für jede Seite."
        }
      },
      success: {
        title: "Zahlung erfolgreich!",
        message: "Ihre Bestellung <strong>#{{orderId}}</strong> wurde erfolgreich aufgegeben und bezahlt.",
        printing: "Wir haben begonnen, die hochauflösenden Seiten zu generieren und Ihr Buch für den Druck vorzubereiten.",
        delivery: "Geschätzte Druck- & Lieferzeit: <strong>12 Tage</strong>.",
        emailNote: "Eine detaillierte Bestätigungs-E-Mail mit allen Informationen zur Sendungsverfolgung wurde an Ihren Posteingang gesendet.",
        contact: "Fragen? Kontaktieren Sie den Support:"
      },
      footer: {
        tagline: "Machen Sie Ihr Kind zum Helden seines eigenen magischen Abenteuers.",
      }
    }
  },
  // ================= РОСИЙСЬКА (RU) =================
  ru: {
    translation: {
      common: {
        back: "Назад",
        next: "Следующий шаг",
        continue: "Продолжить",
        returnHome: "На главную",
        loading: "Загрузка...",
        processing: "Обработка...",
        step: "Шаг"
      },
      nav: {
        getStarted: "Начать",
        howItWorks: "Как это работает",
        faq: "Вопросы и ответы",
        contact: "Контакты",
        followUs: "Мы в соцсетях",
        quickLinks: "Быстрые ссылки"
      },
      home: {
        heroTitle: "Ваш ребенок - главный герой. Сказка, которая оживает на страницах.",
        heroSubtitle: "Превратите одно обычное фото в красивую иллюстрированную книгу, где ваш ребенок становится главным героем — страница за страницей, сцена за сценой.",
        pill1: "Без сложных настроек",
        pill2: "Естественный вид",
        pill3: "Ваш ребенок главный герой на каждой странице",
        ctaStart: "Создать сказку",
        stepsTitle: "Как это работает",
        stepsIntro: "Простые шаги. Волшебный результат.",
        step1Title: "Выберите книгу и загрузите 2 фото",
        step1Text: "Выберите серию из нашей коллекции, введите имя ребенка и приготовьтесь оживить его историю. Затем просто загрузите две четкие фотографии лица, желательно с легкой улыбкой.",
        step1List: {
            li1: "Лицом к камере, без фильтров",
            li2: "Хороший свет, без теней",
            li3: "Спокойное лицо, легкая улыбка"
        },
        step2Title: "Магия персонализации",
        step2Text: "Наши модели бережно переносят черты лица, чтобы ваш ребенок узнавал себя в каждой сцене.",
        step3Title: "Просмотр и Заказ",
        step3Text: "Полистайте страницы онлайн, чтобы убедиться, что все выглядит идеально. Когда будете довольны, переходите к безопасной оплате.",
        step4Title: "Печать и доставка",
        step4Text: "Ваша книга будет напечатана на качественной бумаге с насыщенными цветами, аккуратно упакована и доставлена к вашей двери.",
        qualityTitle: "Почему это так реалистично",
        qualityIntro: "Мелочи имеют большое значение.",
        qualityList: {
            item1Title: "Портретное сходство",
            item1Text: "Мы сохраняем ключевые черты лица и живые эмоции.",
            item2Title: "Один герой",
            item2Text: "Тот же самый ребенок на всех страницах и во всех сценах.",
            item3Title: "Чистые иллюстрации",
            item3Text: "Никакого случайного текста или водяных знаков на картинках.",
            item4Title: "Единый стиль",
            item4Text: "Мягкие цвета, сбалансированная композиция и внимание к деталям."
        },
        get: {
            title: "Что вы получаете",
            item1Title: "Персонализированная книга",
            item1Text: "От первой до последней страницы — история с вашим ребенком в главной роли.",
            item2Title: "Красивые иллюстрации",
            item2Text: "Яркие сцены, созданные для печати, которые приятно рассматривать вместе.",
            item3Title: "Качественная обложка и блок",
            item3Text: "Глянцевая обложка и верстка страниц, подготовленная для профессиональной типографии.",
            item4Title: "Печать и доставка",
            item4Text: "Профессиональная печать и доставка прямо по вашему адресу."
        },
        reviewsTitle: "Счастливые семьи делятся радостью",
        bottomCtaTitle: "Готовы создать волшебную историю?",
        bottomCtaText: "Начните приключение сегодня с книгой, которую вы будете хранить вечно.",
        bottomCtaButton: "Создать историю сейчас"
      },
      faq: {
        q1: "Будет ли герой похож на всех страницах?",
        a1: "Да. Ваш ребенок остается тем же главным персонажем на протяжении всей книги.",
        q2: "Нужно ли много фотографий?",
        a2: "Обычно достаточно одной четкой фотографии анфас с легкой улыбкой.",
        q3: "Могу ли я посмотреть книгу перед оплатой?",
        a3: "Конечно. Вы сможете просмотреть все страницы онлайн и оплатить только тогда, когда вам все понравится.",
        q4: "Сколько занимает печать и доставка?",
        a4: "Это зависит от вашего региона. После оформления заказа мы покажем ориентировочные сроки."
      },
      stepper: {
        step1: "Выбор книги",
        step2: "Данные ребенка",
        step3: "Создание книги",
        step4: "Просмотр и Заказ",
      },
      chooseBook: {
        title: "Выберите историю для ребенка",
        subtitle: "Выберите возрастную группу, а затем — волшебное приключение.",
        ages1_3: "1-3 года",
        ages4_8: "4-8 лет",
        tooltip: "Обложка книги приведена для примера и может отличаться от финального дизайна.",
        titles: {
            102: "Звуки Животных",
            103: "Волшебный Сад",
            201: "Приключение в Волшебном Лесу",
            202: "Маленький Хранитель Фонаря",
            203: "Кем ты можешь стать?",
            301: "Рождественское желание",
            302: "Рождественское путешествие"
        }
      },
      childInfo: {
        title: "Расскажите о маленьком герое",
        subtitle: "Эта информация поможет нам персонализировать историю.",
        uploadTitle: "Загрузка фото",
        clickUpload: "Нажмите, чтобы загрузить",
        guidelines: "Пожалуйста, загрузите две четкие фотографии ребенка (анфас).",
        detailsTitle: "Данные ребенка",
        firstName: "Имя ребенка",
        lastName: "Фамилия ребенка",
        gender: "Пол",
        age: "Возраст",
        email: "Ваш Email",
        options: {
            male: "Мальчик",
            female: "Девочка",
            year: "год",
            years: "лет"
        },
        errors: {
            firstName: "Пожалуйста, введите имя",
            lastName: "Пожалуйста, введите фамилию",
            gender: "Выберите пол",
            age: "Выберите возраст",
            emailRequired: "Введите email",
            emailInvalid: "Неверный формат email",
            photosRequired: "Необходимо загрузить оба фото"
        }
      },
      loading: {
        preparing: "Подготовка кампании...",
        resuming: "Восстановление сессии...",
        creating: "Создание заказа...",
        generating: "Генерация вашей книги...",
        ready: "Готово к просмотру!",
        notify: "Мы отправим вам email, когда книга будет готова к просмотру.",
        waitText: "Пока вы ждете, вот интересные факты:",
        loadingFacts: "Загрузка фактов...",
        error: "Произошла ошибка: {{message}}. Пожалуйста, обновите страницу."
      },
      purchase: {
        reviewTitle: "Проверьте и выберите страницы",
        reviewSubtitle: "Используйте стрелки, чтобы менять варианты страниц. Выбран будет тот вариант, который вы видите.",
        pageCount: "Страница {{current}} из {{total}}",
        variantSelected: "Выбран вариант {{number}}",
        shippingTitle: "Доставка и Оплата",
        contactInfo: "Контактная информация",
        shippingAddr: "Адрес доставки",
        labels: {
            email: "Email",
            firstName: "Имя",
            lastName: "Фамилия",
            country: "Страна",
            address1: "Адрес (Улица, дом)",
            address2: "Адрес 2 (Квартира, подъезд и т.д.)",
            state: "Область / Регион",
            city: "Город",
            zip: "Почтовый индекс",
            phone: "Телефон"
        },
        helpers: {
            address1: "{{length}}/30. (например: ул. Ленина, д. 10)",
            address2: "{{length}}/30. (например: кв. 5, 2 подъезд)"
        },
        payBtn: "Перейти к оплате",
        tabs: {
            select: "Выбор страниц",
            shipping: "Данные доставки"
        },
        errors: {
            email: "Пожалуйста, введите корректный email.",
            required: "Поле {{field}} обязательно.",
            addressLong: "Поле {{field}} не может быть длиннее 30 символов.",
            zipFormat: "Неверный формат индекса для страны {{country}}.",
            zipInvalid: "Почтовый индекс '{{zip}}' не найден в стране {{country}}.",
            zipMismatch: "Индекс '{{zip}}' верный, но он относится к {{stateApi}}, а не к {{stateUser}}.",
            zipApiError: "Не удалось проверить индекс. Попробуйте еще раз.",
            variant: "Пожалуйста, выберите вариант для каждой страницы."
        }
      },
      success: {
        title: "Оплата прошла успешно!",
        message: "Ваш заказ <strong>#{{orderId}}</strong> успешно оформлен и оплачен.",
        printing: "Мы начали генерацию страниц высокого качества и подготовку книги к печати.",
        delivery: "Ориентировочное время печати и доставки: <strong>5-7 дней</strong>.",
        emailNote: "Подробное письмо с подтверждением и трек-номером отправлено вам на почту.",
        contact: "Есть вопросы? Свяжитесь с поддержкой:"
      },
      footer: {
        tagline: "Сделайте вашего ребенка героем его собственной волшебной сказки.",
      },
      pricing: {
        title: "Простая и честная цена",
        badge: "ЛУЧШИЙ ВЫБОР",
        packTitle: "Полный Волшебный Набор",
        packSubtitle: "Одна цена за всё. Никаких скрытых платежей.",
        list: {
            item1: "Персонализированная AI генерация (PDF включен)",
            item2: "Премиум книга в твердом переплете (20x20 см)",
            item3: "Плотная качественная бумага",
            item4: "Бесплатная доставка по всему миру",
            item5: "Приоритетная очередь печати"
        },
        bonusTitle: "БОНУС: Набор для творчества",
        bonusSubtitle: "Включает раскраски и набор премиум маркеров",
        totalPriceLabel: "Итоговая цена",
        price: "2000₽",
        subPrice: "(примерно $24.95)",
        ctaButton: "Создать книгу сейчас",
        guarantee: "100% Гарантия качества"
      },
    }
  }
};